//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"InputFile",1,0],[0,"PositionMethod",1,0]],[[["motorType"],"GenerateMotorModel",{R_:{partTag:"BasePart"}},1,0],[["referenceDesignator"],"CreateMcdLogical",{R_:{logicalNode:"Mechatronics.LogicObject"}},1,0],[["logicalNode","newPartOccs","parameterData"],"EditMcdLogical",{},3,0]],[]];
SPLM.Mechatronics.ImportSelectedMotorsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ImportSelectedMotorsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ImportSelectedMotorsBuilder.MCDPositionMode = Object.freeze({
    "InferredOnly" : "InferredOnly", "AbsoluteOrigin" : "AbsoluteOrigin", "SelectOrigin" : "SelectOrigin", "ByConstraints" : "ByConstraints", "Move" : "Move"});

export default SPLM;